import { reactive } from "vue";
import { deleteAllKeys } from "./utility";

// The reactive, in-memory timetable (the v10 contract, indexed for lookup).
const timetable = reactive({
    students: {},              // StudentID -> Student
    teachers: {},              // SchoolStaffCode -> Teacher
    rooms: {},                 // room_code -> Room
    subjects: {},              // class_code -> Subject
    class_timeslots: [],       // all resolved ClassTimeslot instances
    definitions: [],           // all resolved period definitions
    definitionsBySeqDay: {},   // "seq|day" -> definition (the join key)
    definitionsByGroupDay: {}, // "group|day" -> [definition, ...] sorted by start
    // Indexes built at load so lookups are O(1) instead of scanning every lesson.
    timeslotsByTeacher: {},    // SchoolStaffCode -> [ClassTimeslot]
    timeslotsByRoom: {},       // room_code -> [ClassTimeslot]
    timeslotsByDayRow: {},     // "day|rowKey" -> [ClassTimeslot]
    subjectsByTeacher: {},     // SchoolStaffCode -> [Subject]
    yard_duties: [],
    yard_duty_locations: {},
    heads_of_house: {},
    canvas_exceptions: [],
    substitutions: [],         // easter egg; empty unless the pinkies egg is enabled
    coordinate: null,          // { fileYear, fileSemester, fileType }

    definitionFor(seq, day) {
        return this.definitionsBySeqDay[`${seq}|${day}`] || null;
    },

    empty() {
        deleteAllKeys(timetable.students);
        deleteAllKeys(timetable.teachers);
        deleteAllKeys(timetable.rooms);
        deleteAllKeys(timetable.subjects);
        deleteAllKeys(timetable.class_timeslots);
        deleteAllKeys(timetable.definitions);
        deleteAllKeys(timetable.definitionsBySeqDay);
        deleteAllKeys(timetable.definitionsByGroupDay);
        deleteAllKeys(timetable.timeslotsByTeacher);
        deleteAllKeys(timetable.timeslotsByRoom);
        deleteAllKeys(timetable.timeslotsByDayRow);
        deleteAllKeys(timetable.subjectsByTeacher);
        deleteAllKeys(timetable.yard_duties);
        deleteAllKeys(timetable.yard_duty_locations);
        deleteAllKeys(timetable.heads_of_house);
        deleteAllKeys(timetable.canvas_exceptions);
        deleteAllKeys(timetable.substitutions);
    }
});

// Intentional debugging global. This is NOT dead code: the app never reads
// window.timetable, but ad-hoc analytics/debugging scripts run by hand in the
// browser dev-tools console rely on it. Keep it exposed — do not "clean it up".
window.timetable = timetable;

export default timetable;
